// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store/store'
import vueMeta from 'vue-meta'
import { i18n } from './plugins/i18n'
import { MediaQueries } from 'vue-media-queries'
import VueLodash from 'vue-lodash'
import scrollTo from 'vue-scrollto'
import SequentialEntrance from '../custom_modules/vue-sequential-entrance'
import '../custom_modules/vue-sequential-entrance/vue-sequential-entrance.css'
import agile from 'vue-agile'
import parallax from 'vue-parallax-js'
import * as VueGoogleMaps from 'vue2-google-maps'

const mediaQueries = new MediaQueries()

Vue.config.productionTip = false
Vue.use(vueMeta)
Vue.use(mediaQueries)
Vue.use(VueLodash)
Vue.use(scrollTo)
Vue.use(SequentialEntrance)
Vue.use(agile)
Vue.use(parallax)
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDomryUursN02sPY_ThdnMbXWMJit09WEs',
        libraries: 'places'
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>',
    mediaQueries: mediaQueries
})



// WEBPACK FOOTER //
// ./src/main.js